// src/components/OfferModal.js

import React, { useState } from 'react';

const OfferModal = ({ imageUrls, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handler for the 'Next' button
  const goToNext = () => {
    const isLastSlide = currentIndex === imageUrls.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  // Handler for the 'Previous' button
  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? imageUrls.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  // Show navigation buttons only if there is more than one image
  const showNavButtons = imageUrls.length > 1;

  return (
    <div className="offer-modal-overlay" onClick={onClose}>
      <div className="offer-modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="offer-modal-close-btn">&times;</button>
        
        {showNavButtons && (
          <button onClick={goToPrevious} className="slider-arrow left-arrow">
            &#10094;
          </button>
        )}
        
        <img src={imageUrls[currentIndex]} alt={`Special Offer ${currentIndex + 1}`} />

        {showNavButtons && (
          <button onClick={goToNext} className="slider-arrow right-arrow">
            &#10095;
          </button>
        )}
      </div>
    </div>
  );
};

export default OfferModal;